import { httpV1 as http } from '../api';

const dashboardPath = '/dashboard/dashboard-admin';
const ALT_API_URL = `${process.env.VUE_APP_ALT_BASE_API_URL || process.env.VUE_APP_BASE_API_URL}/v1`;

export async function getProductionPerDay(params) {
  return http
    .get(`${dashboardPath}/production-per-day`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getProposalStatusByPromoter(params) {
  return http
    .get(`${ALT_API_URL}${dashboardPath}/proposal-status-by-promoter`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getPromoterBalance(params) {
  return http
    .get(`${dashboardPath}/promoter-balance`, { params })
    .then(({ data }) => data);
}

export async function getSelfieStatistics(params) {
  return http
    .get(`${dashboardPath}/selfie-statistics`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getDisbursementStatus(params) {
  return http
    .get(`${dashboardPath}/disbursement-status`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getProposalStatus(params) {
  return http
    .get(`${dashboardPath}/proposal-status-chart`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getProposalPaymentByScore(params) {
  return http
    .get(`${dashboardPath}/proposal-payment-by-score`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getWarranty(params) {
  return http
    .get(`${dashboardPath}/warranty-chart`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getUserStatus(params) {
  return http
    .get(`${dashboardPath}/user-status`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getProductionSummary(params) {
  return http
    .get(`${dashboardPath}/production-summary`, { params })
    .then(({ data }) => data);
}

export async function getCorbanProduction(params) {
  return http
    .get(`${dashboardPath}/promoter-monthly-production`, { params })
    .then(({ data }) => data);
}

export async function fetchPromoterProductionCashbackCommission(dateRange, promoters) {
  const params = {
    ...dateRange,
    promoters,
  };

  return http
    .get(`${dashboardPath}/promoter-production-cashback-commission`, { params })
    .then(({ data }) => data);
}

export async function getExternalDashboardUrls() {
  return http
    .get('/dashboard/external')
    .then(({ data }) => data);
}

export async function getBusinessGoals() {
  return http
    .get('/dashboard/business-goals')
    .then(({ data }) => data);
}

export async function getPromoterDemographics(params) {
  return http
    .get(`${dashboardPath}/promoter-demographics`, { params })
    .then(({ data }) => data);
}

export async function getFlowBreakdown(params) {
  return http
    .get(`${dashboardPath}/flow-breakdown`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getFunnelEfficiency(params) {
  return http
    .get(`${dashboardPath}/funnel-efficiency`, { params })
    .then(({ data }) => data);
}

export async function getRiskConcentration(params) {
  return http
    .get(`${dashboardPath}/risk-concentration`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getCltEligibility(params) {
  return http
    .get(`${dashboardPath}/clt-eligibility`, { params })
    .then(({ data }) => data);
}

export async function getCltCompanies(params) {
  return http
    .get(`${dashboardPath}/clt-companies`, { params })
    .then(({ data }) => data);
}

export async function getCltRefusals(params) {
  return http
    .get(`${dashboardPath}/clt-refusals`, { params })
    .then(({ data }) => data);
}

export async function getCltBorrowerEligibility(params) {
  return http
    .get(`${dashboardPath}/clt-borrower-eligibility`, { params })
    .then(({ data }) => data);
}

export async function getBorrowerDemographics(params) {
  return http
    .get(`${dashboardPath}/borrower-demographics`, { params })
    .then(({ data }) => data);
}

export async function getSystemErrors(params) {
  return http
    .get(`${dashboardPath}/system-errors`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getAuctionFunnel(params) {
  return http
    .get(`${dashboardPath}/auction-funnel`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getPromoterHealth(params) {
  return http
    .get(`${dashboardPath}/promoter-health`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getCrossSell(params) {
  return http
    .get(`${dashboardPath}/cross-sell`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getThroughputHeartbeat(params) {
  return http
    .get(`${dashboardPath}/throughput-heartbeat`, { params })
    .then(({ data }) => data);
}

export async function getCommercialGoals(params) {
  return http
    .get(`${dashboardPath}/commercial-goals`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getCommercialReactivations(params) {
  return http
    .get(`${dashboardPath}/commercial-reactivations`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}

export async function getReactivatedHealth(params) {
  return http
    .get(`${dashboardPath}/reactivated-health`, { params: { ...params, output: 'json' } })
    .then(({ data }) => data);
}
